import React, { useRef, useState, forwardRef } from 'react';

import Form from 'rsuite/Form';
import FlexboxGrid from 'rsuite/FlexboxGrid';
import Grid from 'rsuite/Grid';
import Row from 'rsuite/Row';
import Col from 'rsuite/Col';
import { Input, IconButton, Message } from 'rsuite';
import { Notification, useToaster } from 'rsuite';
import TagUnauthorizeIcon from '@rsuite/icons/TagUnauthorize';
import SelectPicker from 'rsuite/SelectPicker';
import api from 'Components/_helpers/api';
import { tipoDeInvalidacion, tipoDocResponsable } from './InvCat'

/*------------- OTHERS ------------------------------------------------------*/
import { NumberType, SchemaModel, StringType } from 'schema-typed';

const Textarea = React.forwardRef((props, ref) => <Input {...props} as="textarea" ref={ref} />);

const model = SchemaModel({
  codigoGeneracionR: StringType().addRule((value, data) => {
    if (data.tipoAnulacion !== 2) return /^[A-F0-9]{8}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{4}-[A-F0-9]{12}$/.test(value);
  }, 'Ingresar un código de generación Válido.'),
  correoReceptor: StringType().isEmail('Correo de receptor no válido').isRequired('Campo requerido'),
  tipoAnulacion: NumberType().isRequired('Campo requerido'),
  motivoAnulacion: StringType().isRequired('Campo requerido').minLength(5, 'La longuitúd minima de este campo son 5 caracteres.'),
  nombreResponsable: StringType().isRequired('Campo requerido'),
  tipDocResponsable: StringType().isRequired('Campo requerido'),
  numDocResponsable: StringType().isRequired('Campo requerido'),
});

const TextField = forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;

  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} accepter={accepter} {...rest} />
    </Form.Group>
  );
});

const TextArea = forwardRef((props, ref) => {
  const { name, label, accepter, ...rest } = props;

  return (
    <Form.Group controlId={`${name}-4`} ref={ref}>
      <Form.ControlLabel>{label} </Form.ControlLabel>
      <Form.Control name={name} rows={3} accepter={Textarea} {...rest} />
    </Form.Group>
  );
});

export default function InvalidationForm(props) {
  const { codigoGeneracion, correoReceptor, emisor, dteType, onInvalidation } = props;
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const toaster = useToaster();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const [, setFormError] = useState({});
  const [formValue, setFormValue] = useState({
    codigoGeneracionR: '',
    correoReceptor: correoReceptor,
    tipoAnulacion: 1,
    motivoAnulacion: '',
    nombreResponsable: emisor.nombre,
    tipDocResponsable: '36',
    numDocResponsable: emisor.nit,
  });

  const handleSubmit = async () => {
    let formStatus = await formRef.current.checkAsync();
    if (formStatus.hasError) {
      return;
    } else {
      setLoading(true);
      api
        .post(`${api.getUri()}${dteType}/Invalidar`, {
          codigoGeneracion: codigoGeneracion,
          codigoGeneracionR: formValue.tipoAnulacion !== 2 ? formValue.codigoGeneracionR : null,
          correoReceptor: formValue.correoReceptor,
          motivoAnulacion: {
            tipoAnulacion: formValue.tipoAnulacion,
            motivoAnulacion: formValue.motivoAnulacion,
            nombreResponsable: formValue.nombreResponsable,
            tipDocResponsable: formValue.tipDocResponsable,
            numDocResponsable: formValue.numDocResponsable,
          },
        })
        .then((res) => {
          toaster.push(
            <Notification type={'warning'} header={`DTE Manager`} closable>
              <p>{`DTE ${codigoGeneracion} anulado correctamente.`}</p>
            </Notification>,
            { placement: 'topEnd' }
          );
          onInvalidation();
        })
        .catch((e) => {
          console.log('error', e);
          if(typeof e.response.data === 'object' && e.response.data !== null) {
            setErrorMessage('Ocurrió un problema al intentar invalidar el DTE')
            setResult(e.response.data);
          }
          else
            setErrorMessage(e.response.data)
        })
        .then(() => setLoading(false));
    }
  };

  const handleChangeForm = (value) => {
    setFormValue(value);
  };

  return (
    <Grid fluid>
      <Row>
        <Col xs={24}>
          <Form ref={formRef} onChange={handleChangeForm} onCheck={setFormError} formValue={formValue} model={model}>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    name="tipoAnulacion"
                    classPrefix="full_width"
                    block
                    accepter={SelectPicker}
                    searchable={false}
                    data={tipoDeInvalidacion}
                    placeholder="Tipo de anulación"
                    label="Tipo de anulación"
                  />
                </Col>
              </Row>
            </Grid>
            {errorMessage && (
              <Message type="error" bordered showIcon>
                <strong>Atención!</strong> {errorMessage}
                {result.validationResult?.errors?.length > 0 && (
                  <div>
                    <ul>
                      {result.validationResult.errors.map((e) => (
                        <li>{e}</li>
                      ))}
                    </ul>
                  </div>
                )}     
                {result.firma?.observaciones?.length > 0 && (
                  <div>
                    <ul>
                      {result.firma.observaciones.map((e) => (
                        <li>{e}</li>
                      ))}
                    </ul>
                  </div>
                )}                
              </Message>
            )}
            {formValue.tipoAnulacion !== 2 && (
              <div>
                <Grid fluid>
                  <Row className="show-grid">
                    <Col xs={24}>
                      <TextField
                        checkAsync
                        name="codigoGeneracionR"
                        classPrefix="full_width"
                        placeholder="Código de generación del documento que reemplaza al documento invalidado"
                        label="Código de generación del documento que reemplaza al documento invalidado"
                      />
                    </Col>
                  </Row>
                </Grid>
              </div>
            )}
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    checkAsync
                    name="correoReceptor"
                    classPrefix="full_width"
                    placeholder="Correo electrónico del receptor"
                    label="Correo electrónico del receptor"
                  />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    checkAsync
                    name="nombreResponsable"
                    classPrefix="full_width"
                    placeholder="Nombre de la persona responsable de invalidar el documento tributario electrónico (Emisor)"
                    label="Nombre del responsable"
                  />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    checkAsync
                    block
                    accepter={SelectPicker}
                    data={tipoDocResponsable}
                    searchable={false}
                    name="tipDocResponsable"
                    classPrefix="full_width"
                    placeholder="Tipo de documento del responsable"
                    label="Tipo de documento de identificación del responsable"
                  />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24}>
                  <TextField
                    checkAsync
                    name="numDocResponsable"
                    classPrefix="full_width"
                    placeholder="Numero de documento de identificación del responsable"
                    label="Numero de documento del responsable"
                    autoComplete="new-email"
                  />
                </Col>
              </Row>
            </Grid>
            <Grid fluid>
              <Row className="show-grid">
                <Col xs={24} md={24}>
                  <TextArea
                    name="motivoAnulacion"
                    classPrefix="full_width"
                    placeholder="Describir el o los campos donde se encuentra el error que ocasiona el evento de invalidación."
                    label="Motivo de anulación"
                  />
                </Col>
              </Row>
            </Grid>

            <FlexboxGrid>
              <FlexboxGrid.Item colspan={24}>
                <IconButton loading={loading} onClick={handleSubmit} appearance={'primary'} color={'red'} icon={<TagUnauthorizeIcon />}>
                  Invalidar DTE (Esta operación no se puede deshacer)
                </IconButton>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </Form>
        </Col>
      </Row>
    </Grid>
  );
}
